export class OffscreenRenderer {
    constructor(canvas, context) {
        this.canvas = canvas;
        this.context = context;
        this.rotation = 0;
    }
    get width() {
        return this.canvas.width;
    }
    get height() {
        return this.canvas.height;
    }
    resetTransform() {
        // Reset transformation matrix to the identity matrix
        this.context.setTransform(1, 0, 0, 1, 0, 0);
    }
}
